import React, { useState } from 'react';
import { Button, Tab } from '@scuf/common';
import { SplitPanelUtil } from '../../commonUtils/SplitPanelUtil';
import { consumeAPIs, IAPIPackage } from '../../commonUtils/APIContext';
import toasts from '../../commonUtils/toasts';
import authService from '../../../authService';
import HierarchyFileDrop from './HierarchyFileDrop';
import i18next from '../../../i18next';

interface IOrganisationHierarchyNewOrgSidePanel extends IAPIPackage {
  onClose: () => void;
  onFinish: () => void;
}

export const OrganisationHierarchyNewOrgSidePanel = (
  props: IOrganisationHierarchyNewOrgSidePanel
) => {
  const [uploadDocumentId, setUploadDocumentId] = useState<string>();
  const [isSendingExcelCommit, setIsSendingExcelCommit] = useState<boolean>(
    false
  );

  const commitExcelUpload = () => {
    if (uploadDocumentId && !isSendingExcelCommit) {
      const offeringIdAndDocumentIdQueries = `?offeringId=${props.offering}&documentId=${uploadDocumentId}`;

      const additionalUploadQueries = `${'&create=true'}`;

      const combinedQuery = `${offeringIdAndDocumentIdQueries}${additionalUploadQueries}`;

      setIsSendingExcelCommit(true);
      authService
        .authFetch(
          `${props.baseURL}/api/v1/organisations/${props.offering}/batch/commit${combinedQuery}`,
          {
            method: 'POST'
          }
        )
        .then(response => {
          if (response.ok) {
            setUploadDocumentId(undefined);
            toasts.success(i18next.t('addOrgSuccess'));
            props.onFinish();
          } else {
            throw new Error(i18next.t('requestFailed'));
          }
        })
        .catch(e => {
          if(e.message ==='Failed to fetch'){
            setUploadDocumentId(undefined);
            toasts.success(i18next.t('addOrgSuccess'));
            props.onFinish();
          }else{
             console.log(i18next.t('excelUploadError'));
             toasts.error(i18next.t('saveError'));
          }
        })
        .finally(() => {
          setIsSendingExcelCommit(false);
        });
    }
  };

  const cancelExcelUpload = () => {
    if (uploadDocumentId) {
      authService.authFetch(
        `${props.baseURL}/api/v1/organisations/${props.offering}/batch/cancel?offeringId=${props.offering}&documentId=${uploadDocumentId}`,
        {
          method: 'POST'
        }
      );
    }
    setUploadDocumentId(undefined);
    props.onClose();
  };

  return (
    <SplitPanelUtil.Panel onOverlayClicked={props.onClose}>
      <SplitPanelUtil.PanelHeader onPanelClose={props.onClose}>
        <SplitPanelUtil.PanelHeaderTitle>
          {i18next.t('newOrg')}
        </SplitPanelUtil.PanelHeaderTitle>
      </SplitPanelUtil.PanelHeader>
      <SplitPanelUtil.PanelContent>
        <Tab defaultActiveIndex={0} onTabChange={() => {}}>
          <Tab.Pane title={i18next.t('upload')}>
            <SplitPanelUtil.PanelContentMain>
              <SplitPanelUtil.PanelContentMainSection>
                <HierarchyFileDrop setUploadDocumentId={setUploadDocumentId} />
              </SplitPanelUtil.PanelContentMainSection>
            </SplitPanelUtil.PanelContentMain>
          </Tab.Pane>
        </Tab>
      </SplitPanelUtil.PanelContent>
      <SplitPanelUtil.PanelFooter>
        <Button type={'secondary'} onClick={cancelExcelUpload}>
          {i18next.t('cancel')}
        </Button>
        <Button
          disabled={!uploadDocumentId}
          onClick={() => commitExcelUpload()}
          loading={isSendingExcelCommit}
        >
          {i18next.t('save')}
        </Button>
      </SplitPanelUtil.PanelFooter>
    </SplitPanelUtil.Panel>
  );
};

export default consumeAPIs(OrganisationHierarchyNewOrgSidePanel);
